var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStorkeWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "warning (2) 1",
    clipPath: "url(#clip0_2_30233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_30233",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 15,
    height: 15
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath2177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2175",
    d: "M-0.000488281 0.491212H13.9995V14.4912H-0.000488281V0.491212Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_30233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2181",
    d: "M2.18701 13.5059H11.812C12.7181 13.5059 13.4526 12.7713 13.4526 11.8652C13.4526 11.5734 13.3765 11.2995 13.2429 11.0621L8.43044 2.31207C8.14929 1.81225 7.61384 1.47461 6.99951 1.47461C6.38521 1.47461 5.84973 1.81225 5.56859 2.31207L0.756086 11.0621C0.622566 11.2995 0.546387 11.5734 0.546387 11.8652C0.546387 12.7713 1.28092 13.5059 2.18701 13.5059Z",
    stroke: "#046C9C",
    strokeWidth: 1.1009,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2185",
    d: "M6.99976 5.30225V8.5835",
    stroke: "#046C9C",
    strokeWidth: 1.1009,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2189",
    d: "M7.54639 10.7715C7.54639 11.0735 7.30155 11.3184 6.99951 11.3184C6.69747 11.3184 6.45264 11.0735 6.45264 10.7715C6.45264 10.4695 6.69747 10.2246 6.99951 10.2246C7.30155 10.2246 7.54639 10.4695 7.54639 10.7715Z",
    fill: "#046C9C"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_30233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.496094)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStorkeWarning);
export default __webpack_public_path__ + "static/media/icon-storke-warning.4195608cec7c3adf0b8aceee28e7ecb2.svg";
export { ForwardRef as ReactComponent };